import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import Header from './indexC'

const mapStateToProps = (state) => {
  const { login, emailVerified, name } = state.authState
  return {
    login: login,
    emailVerified: emailVerified,
    userName: name
  }
}

export default withRouter(connect(
  mapStateToProps
)(Header))



// WEBPACK FOOTER //
// ./src/components/AppHeader/index.js